<template>
  <div :style="{ width: width, height: height }" class="box-container">
    <div class="box-container__header">
      <img alt="" src="@/assets/images/traingle.png" />
      <slot name="header"></slot>
      <div class="moreClass">
        <el-button
          v-if="showButton"
          size="mini"
          type="primary"
          @click="$emit('onAll')"
          >{{ $t("bigScreen.查看全部数据") }}</el-button
        >
        <div v-if="more" @click="$emit('onMore')">
          {{ $t("bigScreen.更多") }}<i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <div class="box-container__content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: "base-card",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    more: {
      type: Boolean,
      default: false,
    },
    showButton: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
.box-container {
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  background: linear-gradient(
    180deg,
    rgba(0, 4, 40, 0.9) 0%,
    rgba(0, 42, 85, 0.9) 100%
  );

  &__header {
    height: 46px;
    background: url("@/assets/images/card-header.png") no-repeat;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 24px;
    color: #ffffff;
    line-height: 24px;
    font-style: normal;
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
    img {
      width: 23px;
      height: 19px;
      margin-left: 12px;
    }
  }

  &__content {
    padding: 20px;
  }
}
.moreClass {
  position: absolute;
  right: 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 24px;
  cursor: pointer;
  display: flex;
  gap: 14px;
  align-items: center;
}
/deep/.el-button--primary {
  background-color: rgba(0, 126, 226);
  border-color: rgba(0, 126, 226);
}
</style>
